export default function cultureGap( el ) {
	if ( ! el ) {
		return;
	}

	const slider = el.querySelector( '.b-cgap-slider' );
	if ( ! slider ) {
		return;
	}

	const flkty = new Flickity( slider, {
		cellAlign: 'left',
		contain: true,
		groupCells: false,
		wrapAround: false,
		pageDots: false,
		prevNextButtons: false,
		adaptiveHeight: false,
		initialIndex: 1, // Start on the second slide (middle card)
		// Responsive options
		responsive: [
			{
				breakpoint: 768,
				settings: {
					cellAlign: 'center',
					pageDots: true,
					prevNextButtons: false,
					initialIndex: 2
				}
			}
		]
	} );

	// Equalize card heights after Flickity is initialized
	function equalizeHeights() {
		const cards = slider.querySelectorAll( '.b-cgap-card' );
		let maxHeight = 0;

		// Reset heights first
		cards.forEach( function( card ) {
			card.style.height = 'auto';
		} );

		// Find the tallest card
		cards.forEach( function( card ) {
			const cardHeight = card.offsetHeight;
			if ( cardHeight > maxHeight ) {
				maxHeight = cardHeight;
			}
		} );

		// Set all cards to the same height
		cards.forEach( function( card ) {
			card.style.height = maxHeight + 'px';
		} );

		flkty.resize(); // Make sure Flickity updates its layout
	}

	// Initial height equalization
	setTimeout( equalizeHeights, 100 );

	// Re-equalize on window resize
	let resizeTimeout;
	window.addEventListener( 'resize', function() {
		clearTimeout( resizeTimeout );
		resizeTimeout = setTimeout( equalizeHeights, 250 );
	} );
}
